module.exports = __webpack_public_path__ + "static/media/sy.68891741.webp";